import { personalDataApi } from '@/api'
import { PersonalData } from '@/models'

export default {
  namespaced: true,

  state: {
    personalData: new PersonalData()
  },

  getters: {
    personalDataId: state => {
      return { id: state.personalData.id }
    }
  },

  mutations: {
    setPersonalData(state, payload) {
      state.personalData = payload
    },

    clearState(state) {
      state.personalData = new PersonalData()
    },
  },

  actions: {
    async GET_PERSONAL_DATA({ commit }) {
      try {
        const data = await personalDataApi.findByCurrentUser()
        if (data.id) {
          commit('setPersonalData', data)
        }
        return data
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async CREATE_PERSONAL_DATA({ commit, state }, payload) {
      try {
        const data = await personalDataApi.create(payload)
        if (data.id) {
          commit('setPersonalData', data)
        }
        return data
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async UPDATE_PERSONAL_DATA({ commit }, payload) {
      try {
        commit('setPersonalData', payload)
        return await personalDataApi.update(payload)
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    }
  }
}
